export const useStyles = (isDebug: boolean = false) => {
  return {
    homeBarButton: {
      '& button': {
        width: isDebug ? 56 : 28,
        height: isDebug ? 56 : 28,
      },
    },
    iconContainer: {
      width: isDebug ? 56 : 28,
      height: isDebug ? 56 : 28,
      position: 'absolute' as 'absolute',
    },
    icon: {
      width: '100%',
      height: 'auto',
      borderRadius: '50%',
      overflow: 'hidden',
      border: '1px solid white',
    },
  };
};
